var watchlistPositionAdd = {
	title: "Agregar posición",
	subtitle: "Lista de Seguimiento: {value}",
	noSelectedPositions: "Actualmente, no hay posiciones seleccionadas para agregar a la lista de seguimiento",
	singleSelectedPosition: "Hay 1 posición seleccionada para agregar a la lista de seguimiento",
	multipleSelectedPositions: "Hay {value} posiciones seleccionadas para agregar a la lista de seguimiento",
	submit: "Enviar",
	cancel: "Cancelar",
	remove: "Eliminar",
	validationErrors: {
		positionExists: "Su selección ya está en su lista de seguimiento"
	},
	noWatchlists: {
		title: "Info",
		message: "Aún no se ha creado ninguna lista de seguimiento."
	}
};
var es = {
	watchlistPositionAdd: watchlistPositionAdd
};

export { es as default, watchlistPositionAdd };
